"use strict";import{IconChevronDown as o}from"../src/elements/IconChevronDown.js";import{defineElement as n}from"@spectrum-web-components/base/src/define-element.js";n("sp-icon-chevron-down",o);
//# sourceMappingURL=sp-icon-chevron-down.js.map
